import React from 'react';
import './msg.css';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { messagesAction } from "../../redux/rootReducer";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import { getUserInfoSagaAction } from "../../redux/sagaActions";
import { site } from "../../config";

const Msg = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const messages = useSelector(state => state.messages);

    // Расчёт отступа для сообщения
    const getIndent = index => {
        let indent = 0;

        if (!index) return indent;

        if (messages.length > 5) {
            for (let i = 0; i < index; i++) {
                indent += 12;
            }
        }
        else {
            for (let i = 0; i < index; i++) {
                indent += messages[index - 1].nodeRef.current?.clientWidth + 12;
            }
        }

        return indent + 'px';
    };

    return (
        <div className="msg">
            { messages.length > 1 && <div className="msg__clear" onClick={ () => dispatch(messagesAction([])) }>Закрыть всё</div> }
            <TransitionGroup className="msg__items">
                {
                    messages.map((msg, index) => {
                        return (
                            <CSSTransition
                                classNames="msg__item"
                                key={ msg.id }
                                timeout={ 500 }
                                nodeRef={ msg.nodeRef }
                            >
                                <div className="msg__item"
                                     ref={ msg.nodeRef }
                                     onClick={ () => {
                                         // Переходим в карточку клиента
                                         history.push('/fitness/users');
                                         dispatch(getUserInfoSagaAction({ id: msg.id }));
                                         dispatch(messagesAction(messages.filter(el => el.id !== msg.id)));
                                     } }
                                     style={{ marginLeft: getIndent(index) }}
                                >
                                    {
                                        msg.img
                                        ?
                                            <div className="msg__img" style={{ backgroundImage: `url(${ site + msg.img })`, backgroundSize: 'cover' }}/>
                                        :   <div className="msg__img"/>
                                    }

                                    <div className="msg__name">{ msg.name }</div>
                                    <div className="msg__remove"
                                         onClick={ event => {
                                             event.preventDefault();
                                             event.stopPropagation();
                                             dispatch(messagesAction(messages.filter(el => el.id !== msg.id)));
                                         } }
                                    />
                                </div>
                            </CSSTransition>
                        );
                    })
                }
            </TransitionGroup>
        </div>
    );
};

export default Msg;